module.exports = __webpack_public_path__ + "img/gallery-arrow.fd90e441.svg";